import type { BaseApiClientResponse, LocalizedFieldError, ResponceError } from '../types';
import { DEFAULT_ERROR_KEY, ERROR_PREFIX } from './constants';

export class LocalizedResponseError extends Error {
    public statusCode = 0;
    public errors: LocalizedFieldError[];
    public isKnownError = false;

    public static fromResponce(resp: BaseApiClientResponse) {
        return new LocalizedResponseError(resp.error, resp);
    }

    public constructor(
        { errors, statusCode }: ResponceError = {
            statusCode: 0,
            errors: [],
        },
        public original?: BaseApiClientResponse,
    ) {
        super();
        this.statusCode = statusCode || 0;
        if (errors) {
            if (errors.length > 0) {
                this.isKnownError = true;
            }
            if (!Array.isArray(errors) || !errors.length) {
                errors = [
                    {
                        i18Key: DEFAULT_ERROR_KEY,
                        message: '',
                        field: '',
                        error: DEFAULT_ERROR_KEY,
                    },
                ];
            }
            this.errors = errors.map(error => {
                const i18Key = error.error ? `${ERROR_PREFIX}${error.error}`.toLowerCase() : DEFAULT_ERROR_KEY;

                return {
                    error: error.error,
                    i18Key,
                    field: error.field,
                    message: error.message,
                };
            }) as LocalizedFieldError[];
        } else {
            this.errors = [];
        }
    }

    public toString() {
        return this.errors[0].i18Key;
    }

    public hasError(name: string): boolean {
        return this.errors.some(error => error.error === name);
    }
}
